import { useQuery } from '@tanstack/react-query';
import { getVacantUnitsRequest } from '@/api';
import { useAuth } from '@/context/AuthContext';
import { VacantUnitsSearchParams } from '@/types/api-types';

function useGetVacantUnits(params?: VacantUnitsSearchParams) {
  const { isAuthenticated } = useAuth();
  return useQuery({
    queryKey: ['vacant-units', params],
    queryFn: () => getVacantUnitsRequest(params),
    enabled: isAuthenticated,
  });
}

export default useGetVacantUnits;
